import * as React from 'react';
import { Col, ControlLabel, FormControl, FormGroup, Row, Checkbox } from 'react-bootstrap';
import { Translate } from '../../../../shared/LanguageService';
import { ICreateOrderAddress, ICreateOrderContact, ICreateOrderOther } from '../../Entities';
import FieldInfoIcon from '../../../../components/common/FieldInfoIcon';
import FormSelect from '../../../../components/common/FormSelect';
import AddressMapButton from '../../../../components/common/addressValidation/AddressMapButton';
import ICoordinate from '../../../map/ICoordinate';
import { phoneRegexp } from '../../../../shared/ValidationRegexp';
import CountryCodePhoneNumberInput from '../../../../components/common/CountryCodePhoneNumberInput';

interface IProps {
    contactInfo: ICreateOrderContact;
    addressInfo: ICreateOrderAddress;
    otherInfo: ICreateOrderOther;
    objectTypes: any[];
    nrOfPlans: number;
    onChange: (collection: string, key: string, evt: any, rawValue?: string) => void;
    onAddressPointLocationChange: (value: ICoordinate) => void;
    onAddressValidationChange: (isValid: boolean) => void;
    onNrOfPlansChange: (evt: any) => void;
    objectTypeLockDown: any;
    enableNumberOfPlans: boolean;
    phoneToValidate: string;
}

class ScandphotosCreateOrderContactPage extends React.Component<IProps, null> {
    constructor(props: any, context: any) {
        super(props, context);
    }

    phoneNumberValidator(phoneNumber: string): 'success' | 'warning' | 'error' {
        if (phoneNumber && phoneNumber !== '' && !phoneRegexp.test(phoneNumber)) {
            return 'error';
        }
    }

    objectIsApartment(objectType: number) {
        try {
            return Number(objectType) === 1;
        } catch (ex) {
            return false;
        }
    }

    objectIsVilla(objectType: number) {
        try {
            return Number(objectType) === 2;
        } catch (ex) {
            return false;
        }
    }

    enableNumberOfPlans() {
        return this.props.enableNumberOfPlans === true;
    }

    selectedPhoneNumberForValue(value: any) {
        if (this.props.contactInfo.ownerPrimaryPhoneNumber) {
            return {
                ownerPhoneAsValue: 'ownerPrimaryPhoneNumber',
                ownerPhoneValue: value
            };
        } else if (this.props.contactInfo.ownerSecondaryPhoneNumber) {
            return {
                ownerPhoneAsValue: 'ownerSecondaryPhoneNumber',
                ownerPhoneValue: value
            };
        } else {
            return {
                ownerPhoneAsValue: 'ownerSecondaryPhoneNumber',
                ownerPhoneValue: value
            };
        }
    }

    render() {
        return (
            <fieldset>
                <Col md={6}>
                    <h2>{Translate('scandphotos/orders/create/subview/contact/label/seller')}</h2>
                    <FormGroup className="required">
                        <ControlLabel>
                            {Translate(
                                'scandphotos/orders/create/subview/order-contact/label/firstname'
                            )}
                        </ControlLabel>
                        <FormControl
                            data-testid="scandphotos-owner-firstname"
                            type="text"
                            value={
                                this.props.contactInfo && this.props.contactInfo.ownerFirstName
                                    ? this.props.contactInfo.ownerFirstName
                                    : ''
                            }
                            onChange={(value) => {
                                this.props.onChange('contactInfo', 'ownerFirstName', value);
                            }}
                        />
                    </FormGroup>
                    <FormGroup className="required">
                        <ControlLabel>
                            {Translate(
                                'scandphotos/orders/create/subview/order-contact/label/lastname'
                            )}
                        </ControlLabel>
                        <FormControl
                            data-testid="scandphotos-owner-lastname"
                            type="text"
                            value={
                                this.props.contactInfo && this.props.contactInfo.ownerLastName
                                    ? this.props.contactInfo.ownerLastName
                                    : ''
                            }
                            onChange={(value) => {
                                this.props.onChange('contactInfo', 'ownerLastName', value);
                            }}
                        />
                    </FormGroup>
                    <FormGroup
                        validationState={this.phoneNumberValidator(this.props.phoneToValidate)}
                    >
                        <ControlLabel>
                            {Translate(
                                'scandphotos/orders/create/subview/order-contact/label/phone'
                            )}
                        </ControlLabel>
                        <FieldInfoIcon
                            title={Translate('popover/info/title/phonenumber')}
                            content={Translate('popover/info/content/phonenumber')}
                        />
                        <CountryCodePhoneNumberInput
                            value={
                                this.props.contactInfo && this.props.contactInfo.ownerPrimaryPhoneNumber
                                    ? this.props.contactInfo.ownerPrimaryPhoneNumber
                                    : this.props.contactInfo && this.props.contactInfo.ownerSecondaryPhoneNumber
                                        ? this.props.contactInfo.ownerSecondaryPhoneNumber
                                        : ''
                            }
                            onChange={(value) => {
                                this.props.onChange(
                                    'contactInfo',
                                    this.selectedPhoneNumberForValue(value).ownerPhoneAsValue,
                                    this.selectedPhoneNumberForValue(value).ownerPhoneValue,
                                    value
                                );
                            }}
                        />
                    </FormGroup>

                    <h2>{Translate('scandphotos/orders/create/subview/contact/label/address')}</h2>

                    <FormGroup className="required">
                        <ControlLabel>
                            {Translate(
                                'scandphotos/orders/create/subview/order-contact/label/street-address'
                            )}
                        </ControlLabel>
                        <FormControl
                            data-testid="scandphotos-address-line"
                            type="text"
                            value={
                                this.props.addressInfo && this.props.addressInfo.addressLine1
                                    ? this.props.addressInfo.addressLine1
                                    : ''
                            }
                            onChange={(value) => {
                                this.props.onChange('addressInfo', 'addressLine1', value);
                            }}
                        />
                    </FormGroup>
                    <Row>
                        <Col xs={5}>
                            <FormGroup className="required">
                                <ControlLabel>
                                    {Translate(
                                        'scandphotos/orders/create/subview/order-contact/label/postal-code'
                                    )}
                                </ControlLabel>
                                <FormControl
                                    data-testid="scandphotos-address-postal"
                                    type="text"
                                    value={
                                        this.props.addressInfo &&
                                        this.props.addressInfo.addressPostalNumber
                                            ? this.props.addressInfo.addressPostalNumber
                                            : ''
                                    }
                                    onChange={(value) => {
                                        this.props.onChange(
                                            'addressInfo',
                                            'addressPostalNumber',
                                            value
                                        );
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={6}>
                            <FormGroup className="required">
                                <ControlLabel>
                                    {Translate(
                                        'scandphotos/orders/create/subview/order-contact/label/city'
                                    )}
                                </ControlLabel>
                                <FormControl
                                    data-testid="scandphotos-address-city"
                                    type="text"
                                    value={
                                        this.props.addressInfo && this.props.addressInfo.addressCity
                                            ? this.props.addressInfo.addressCity
                                            : ''
                                    }
                                    onChange={(value) => {
                                        this.props.onChange('addressInfo', 'addressCity', value);
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <AddressMapButton
                            addressLine={this.props.addressInfo.addressLine1}
                            onAddressLineChange={(addressLine1: string) =>
                                this.props.onChange('addressInfo', 'addressLine1', addressLine1)
                            }
                            postalNumber={this.props.addressInfo.addressPostalNumber}
                            onPostalNumberChange={(postalNumber: string) =>
                                this.props.onChange(
                                    'addressInfo',
                                    'addressPostalNumber',
                                    postalNumber
                                )
                            }
                            city={this.props.addressInfo.addressCity}
                            onCityChange={(city: string) =>
                                this.props.onChange('addressInfo', 'addressCity', city)
                            }
                            point={this.props.addressInfo.addressPointLocation}
                            onPointChange={(point: ICoordinate) =>
                                this.props.onAddressPointLocationChange(point)
                            }
                            error={null}
                            onValidationChange={this.props.onAddressValidationChange}
                        />
                    </Row>
                    <FormGroup>
                        <Checkbox
                            checked={
                                this.props.otherInfo &&
                                this.props.otherInfo.willOrderCreatorAttendWhenPhotographing
                            }
                            onChange={() => {
                                this.props.onChange(
                                    'otherInfo',
                                    'willOrderCreatorAttendWhenPhotographing',
                                    !this.props.otherInfo.willOrderCreatorAttendWhenPhotographing
                                );
                            }}
                        >
                            <span>
                                {Translate(
                                    'scandphotos/orders/create/subview/order-contact/label/creator-will-attend'
                                )}
                            </span>
                        </Checkbox>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <h2>{Translate('scandphotos/orders/create/subview/contact/label/object')}</h2>
                    <FormGroup className="required">
                        <ControlLabel>
                            {Translate(
                                'scandphotos/orders/create/subview/order-contact/label/object-type'
                            )}
                        </ControlLabel>
                        <FormSelect
                            data-testid="scandphotos-object-type"
                            autoFocus={true}
                            value={this.props.addressInfo.objectType.toString()}
                            onChange={(value) => {
                                this.props.onChange('addressInfo', 'objectType', value);
                            }}
                        >
                            {this.props.objectTypes
                                .filter((x: any) => {
                                    return (
                                        (x.value === 0 && !this.props.objectTypeLockDown) ||
                                        !this.props.objectTypeLockDown ||
                                        x.value === this.props.objectTypeLockDown.value
                                    );
                                })
                                .map((x: any) => {
                                    return (
                                        <option value={x.value} key={x.value}>
                                            {x.value > 0 ? Translate(x.displayName) : ''}
                                        </option>
                                    );
                                })}
                        </FormSelect>
                    </FormGroup>
                    {this.enableNumberOfPlans() && (
                        <FormGroup className="required">
                            <ControlLabel>
                                {Translate(
                                    'scandphotos/orders/create/subview/order-contact/label/nr-of-plans'
                                )}
                            </ControlLabel>
                            <FormControl
                                type="number"
                                value={this.props.nrOfPlans ? this.props.nrOfPlans.toString() : ''}
                                onChange={(value) => {
                                    this.props.onNrOfPlansChange(value);
                                }}
                            />
                        </FormGroup>
                    )}

                    {this.objectIsApartment(this.props.addressInfo.objectType) && (
                        <FormGroup className="required">
                            <ControlLabel>
                                {Translate(
                                    'scandphotos/orders/create/subview/order-contact/label/nr-of-rooms'
                                )}
                            </ControlLabel>
                            <FormControl
                                data-testid="scandphotos-object-rooms"
                                type="number"
                                value={
                                    this.props.addressInfo &&
                                    this.props.addressInfo.objectNumberOfRooms
                                        ? this.props.addressInfo.objectNumberOfRooms
                                        : ''
                                }
                                onChange={(value) => {
                                    this.props.onChange(
                                        'addressInfo',
                                        'objectNumberOfRooms',
                                        value
                                    );
                                }}
                            />
                        </FormGroup>
                    )}

                    {this.objectIsVilla(this.props.addressInfo.objectType) && (
                        <FormGroup className="required">
                            <ControlLabel>
                                {Translate(
                                    'scandphotos/orders/create/subview/order-contact/label/object-area-square-meters'
                                )}
                            </ControlLabel>
                            <FormControl
                                data-testid="scandphotos-object-area"
                                type="number"
                                value={
                                    this.props.addressInfo &&
                                    this.props.addressInfo.objectAreaSquareMeters
                                        ? this.props.addressInfo.objectAreaSquareMeters
                                        : ''
                                }
                                onChange={(value) => {
                                    this.props.onChange(
                                        'addressInfo',
                                        'objectAreaSquareMeters',
                                        value
                                    );
                                }}
                            />
                        </FormGroup>
                    )}

                    {this.objectIsApartment(this.props.addressInfo.objectType) && (
                        <FormGroup className="required">
                            <ControlLabel>
                                {Translate(
                                    'scandphotos/orders/create/subview/order-contact/label/apartment-floor'
                                )}
                            </ControlLabel>
                            <FormControl
                                data-testid="scandphotos-object-floor"
                                type="text"
                                value={
                                    this.props.addressInfo && this.props.addressInfo.apartmentFloor
                                        ? this.props.addressInfo.apartmentFloor
                                        : ''
                                }
                                onChange={(value) => {
                                    this.props.onChange('addressInfo', 'apartmentFloor', value);
                                }}
                            />
                        </FormGroup>
                    )}

                    {this.objectIsApartment(this.props.addressInfo.objectType) && (
                        <FormGroup>
                            <Checkbox
                                checked={
                                    this.props.addressInfo &&
                                    this.props.addressInfo.apartmentHasBalcony
                                }
                                onChange={() => {
                                    this.props.onChange(
                                        'addressInfo',
                                        'apartmentHasBalcony',
                                        !this.props.addressInfo.apartmentHasBalcony
                                    );
                                }}
                            >
                                <span>
                                    {Translate(
                                        'scandphotos/orders/create/subview/order-contact/label/apartment-has-balcony'
                                    )}
                                </span>
                            </Checkbox>
                        </FormGroup>
                    )}

                    {this.objectIsApartment(this.props.addressInfo.objectType) && (
                        <FormGroup>
                            <ControlLabel>
                                {Translate(
                                    'scandphotos/orders/create/subview/order-contact/label/apartment-accesscode'
                                )}
                            </ControlLabel>
                            <FormControl
                                type="text"
                                value={
                                    this.props.addressInfo &&
                                    this.props.addressInfo.apartmentAccessCode
                                        ? this.props.addressInfo.apartmentAccessCode
                                        : ''
                                }
                                onChange={(value) => {
                                    this.props.onChange(
                                        'addressInfo',
                                        'apartmentAccessCode',
                                        value
                                    );
                                }}
                            />
                        </FormGroup>
                    )}
                </Col>
            </fieldset>
        );
    }
}

export default ScandphotosCreateOrderContactPage;
